import { render, staticRenderFns } from "./TableJson.vue?vue&type=template&id=4b538e86&scoped=true&"
import script from "./TableJson.vue?vue&type=script&lang=js&"
export * from "./TableJson.vue?vue&type=script&lang=js&"
import style0 from "./TableJson.vue?vue&type=style&index=0&id=4b538e86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b538e86",
  null
  
)

export default component.exports